var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"ma-0 pa-0",attrs:{"cols":"12","md":"5"}},[_c('div',{staticClass:"renderpane"},[_c('data-render-toolbar'),_c('data-render-canvas')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }